import React from "react"
import clsx from "clsx"
import { BaseStyles } from "ui/types/base-styles"
import { generateStylesFromProps } from "ui/utils/styles"

import styles from "./Spinner.module.css"

function Spinner({
  white,
  $size,
  $color,
  $borderWidth,
  className = "",
  style = {},
  ...rest
}: {
  white?: boolean
  $size?: string
  $color?: string
  $borderWidth?: number
  className?: string
  style?: React.CSSProperties
} & BaseStyles) {
  const generatedStyles = generateStylesFromProps(rest)

  const wrapperClasses = clsx(styles.wrapper, className)

  const wrapperStyles = {
    ...generatedStyles,
    ...style,
  }

  const spinnerStyles = {
    width: $size || "30px",
    height: $size || "30px",
  }

  const spinnerDivStyles = {
    width: $size || "30px",
    height: $size || "30px",
    borderWidth: `${$borderWidth || 4}px`,
    borderColor: `var(--color-${white ? "white" : $color || "primary"}) transparent transparent transparent`,
    borderTopColor: `var(--color-${white ? "white" : $color || "primary"})`,
  }

  return (
    <div className={wrapperClasses} style={wrapperStyles}>
      <div className={styles.content}>
        <div className={styles.spinner} style={spinnerStyles}>
          <div style={spinnerDivStyles}></div>
          <div style={spinnerDivStyles}></div>
          <div style={spinnerDivStyles}></div>
          <div style={spinnerDivStyles}></div>
        </div>
      </div>
    </div>
  )
}

export default Spinner
